// extracted by mini-css-extract-plugin
export var h1 = "Typography-module--h1--45c8b";
export var h2 = "Typography-module--h2--0c1e8";
export var h3 = "Typography-module--h3--53824";
export var h4 = "Typography-module--h4--1bc44";
export var p1 = "Typography-module--p1--4b9ba";
export var p2 = "Typography-module--p2--4d1a9";
export var p3 = "Typography-module--p3--8ae47";
export var trademark = "Typography-module--trademark--96ac8";
export var weightBold = "Typography-module--weightBold--01ca4";
export var weightMedium = "Typography-module--weightMedium--91695";